import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  GoogleAnalyticsAction,
  GoogleAnalyticsCategory,
} from '../../../../shared/services/google-analytics/google-analytics.model';
import { GoogleAnalyticsService } from '../../../../shared/services/google-analytics/google-analytics.service';
import { OpenPageModel, OpenPageService } from '../../services/open-page.service';

const LANG_DE = 'de';

@Component({
    selector: 'app-menu-controls',
    templateUrl: './menu-controls.component.html',
    styleUrls: ['./menu-controls.component.css'],
    standalone: false
})
export class MenuControlsComponent implements OnInit {
  @Output() public readonly exit: EventEmitter<void> = new EventEmitter();

  openPage: OpenPageModel;

  constructor(
    public translate: TranslateService,
    public openPageService: OpenPageService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.openPageService.currentOpenPage.subscribe(openPage => {
      this.openPage = openPage;
    });
  }

  openContactView(): void {
    this.googleAnalyticsService.sendEvent(
      GoogleAnalyticsCategory.HELP,
      GoogleAnalyticsAction.HELP_CONTACT,
      'Vaylens contact page'
    );
    if (LANG_DE === this.translate.getCurrentLang()) {
      window.open('https://vaylens.com/de/unternehmen/kontakt', '_blank', 'noopener');
    } else {
      window.open('https://vaylens.com/company/contact-us', '_blank', 'noopener');
    }
  }

  openImprintView(): void {
    this.googleAnalyticsService.sendEvent(
      GoogleAnalyticsCategory.HELP,
      GoogleAnalyticsAction.LEGAL_DISPLAY,
      'Vaylens legal information'
    );
    if (LANG_DE === this.translate.getCurrentLang()) {
      window.open('https://vaylens.com/de/impressum', '_blank', 'noopener');
    } else {
      window.open('https://vaylens.com/legal-notice', '_blank', 'noopener');
    }
  }

  openPrivacyView(): void {
    this.googleAnalyticsService.sendEvent(
      GoogleAnalyticsCategory.HELP,
      GoogleAnalyticsAction.LEGAL_DISPLAY,
      'PRIVACY'
    );
    if (LANG_DE === this.translate.getCurrentLang()) {
      window.open('https://vaylens.com/de/datenschutz', '_blank', 'noopener');
    } else {
      window.open('https://vaylens.com/privacy-policy', '_blank', 'noopener');
    }
  }

  openTermsView(): void {
    this.googleAnalyticsService.sendEvent(
      GoogleAnalyticsCategory.HELP,
      GoogleAnalyticsAction.LEGAL_DISPLAY,
      null
    );
    this.openPage.termsOpen = true;
    this.openSelectedPage();
  }

  openHelpView(): void {
    this.googleAnalyticsService.sendEvent(
      GoogleAnalyticsCategory.HELP,
      GoogleAnalyticsAction.HELP_DISPLAY,
      null
    );
    this.openPage.helpOpen = true;
    this.openSelectedPage();
  }

  private openSelectedPage(): void {
    this.openPage.selectedPageOpen = true;
    this.openPageService.changeOpenPage(this.openPage);
  }
}
